export enum VerticalAlignments {
    TOP = "top",
    MIDDLE = "middle",
    BOTTOM = "bottom",
}
